<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="editForm" :rules="rules" ref="editForm">
          <div>
            <el-row>

              <el-col :span="12" class="item">
                <el-form-item label="机构名称" required prop="name">
                  <el-input v-model="editForm.name" placeholder="输入机构名称"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="经纬度">
                  <el-input v-model="lonlatstr" disabled placeholder="请抓取经纬度" class="homeAddress">
                    <el-button slot="append" @click="openBaiduMap">抓取</el-button>
                  </el-input>
                </el-form-item>
              </el-col>

            </el-row>

            <el-row>

              <el-col :span="12" class="item">
                <el-form-item label="地址">
                  <el-input v-model="editForm.address" placeholder="输入地址"></el-input>
                </el-form-item>
              </el-col>


            </el-row>
          </div>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm('editForm')">提交</el-button>
      </div>
    </div>


    <BaiduMap ref="baiduMap" v-show="baiduMapShow" v-on:closeMap="closeMap" v-on:setMap="setMap"></BaiduMap>


  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import BaiduMap from "./BaiduMap";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      baiduMapShow: false,

      loading: false,

      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        name:'',
        address:'',
        lon:'',
        lat:'',

        institutionCode:'',
      },

      statusArr: [{
        value: 1,
        label: '正常'
      }, {
        value: 2,
        label: '禁用'
      }],

      types: [
        {
          value: 1, label: '院护'
        }, {
          value: 2, label: '家护'
        }, {
          value: 3, label: '日护'
        }, {
          value: 4, label: '综合护'
        }
      ],

      rules:{

        name:[
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        address:[
          { required: true, message: '请输入地址', trigger: 'blur' },
        ],

      },

      lonlatstr:'',

    }
  },
  components: {
    BaiduMap
  },
  methods: {
    init(row){
      this.$refs.editForm.resetFields();

      this.editForm.name=row.userDTO.name;
      this.editForm.address=row.address;
      this.editForm.lon = row.lon;
      this.editForm.lat = row.lat;

      this.lonlatstr = row.lon+','+row.lat;

      this.editForm.institutionCode = row.institutionCode;

    },
    closeSelf() {
      this.$emit("closeEdit");
    },

    openBaiduMap() {
      let gcLonLat = this.bd_encrypta(this.editForm.lon,this.editForm.lat);
      this.$refs.baiduMap.init2(gcLonLat[0],gcLonLat[1]);
      this.baiduMapShow = true;
    },

    closeMap() {
      this.baiduMapShow = false
    },
    setMap(info) {
      this.baiduMapShow = false

      let gcLonLat = this.bMapTransWXMap(info.lng,info.lat);
      this.editForm.lon = gcLonLat[0];
      this.editForm.lat = gcLonLat[1];

      this.lonlatstr = info.lng +","+info.lat;

    },
    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          return false;
        }
      })
    },
    addSubmit(){


      if(this.editForm.lon == ''){
        this.$message({type: 'info', message: '请抓取经纬度'});
        return;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }


      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/EditByGov",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'warning', message: response.data.message});
            }
          }
      )
    },

    changeStatus:function (selVal) {
      this.editForm.status = selVal;
    },


    // GCJ-02 to BD-09
    bd_encrypta(gg_lon, gg_lat) {
      var X_PI = Math.PI * 3000.0 / 180.0;
      var x = gg_lon, y = gg_lat;
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
      var bd_lon = z * Math.cos(theta) + 0.0065;
      var bd_lat = z * Math.sin(theta) + 0.006;
      return [bd_lon, bd_lat]
    },

    // BD-09 to GCJ-02
    bMapTransWXMap(lng, lat) {
      let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);
      return [lngs, lats]
    },

  }
}
</script>

